export default __webpack_public_path__ + "static/media/Goal-bull's-eye.f6f829e1.svg";